<div class = "ispm-checkbox-group">
    <gen-dynamic-form
        [formName]="widgetConfigPayload?.formId"
        [editMode]="widgetConfigPayload?.editMode"
        [formData] = "formData"
        [disabled]="widgetConfigPayload?.disabled"
        [formVertical]="true"
        [stayInFormMode]="true"
        [requiredMessage]="''"
        [defaultList]="_defaultList"
        [listenToDataChange]="true"

        (formChange)="formChange($event.form)">
</gen-dynamic-form>
<ng-container *ngIf="showAutoComplete">
<p-autoComplete   [(ngModel)]="currentSelected"
                  placeholder= {{widgetConfigPayload?.placeholder}}  inputId="histopathology" inputStyleClass="form-control"
                [appendTo]="'body'"
                immutable="true"
                emptyMessage="Not Found"
                [suggestions]="options$|async"
                (completeMethod)="search($event)"
                  [forceSelection]="false"
                  (onSelect)="updateTouched($event,false)"
                  (onKeyUp)="onEnterEmitter($event)"
                  inputId="histopathology" field="display">
</p-autoComplete>
</ng-container>
<gen-button  class="top-panel add-button" *ngIf="isAddItemsAvailable()"
             [ngClass]="uniqueButtonName | automationLocator:'BUTTON'"
             (click)="addClicked()"
             [type]="'emphasis'"
             [text]="addButtonText"
             [disabled]="widgetConfigPayload?.disabled"
             [iconClass]="'icon__plus'">
</gen-button>
</div>